import { useTranslation } from 'react-i18next';

import BillingContactCard from '../../../../../../../../shared/components/ProfileCards/BillingContactCard/BillingContactCard';
import CompanyCard from '../../../../../../../../shared/components/ProfileCards/CompanyCard/CompanyCard';
import PrimaryContactCard from '../../../../../../../../shared/components/ProfileCards/PrimaryContactCard/PrimaryContactCard';
import type { IProspect } from '../../../../../../../../shared/interfaces/prospects';
import { TRANSLATIONS_CLIENTS } from '../../../../../../../../shared/translations/clients';
import { TRANSLATIONS_PROSPECTS } from '../../../../../../../../shared/translations/prospects';

const noopAsync = async (): Promise<void> => {};
const noopValidChange = (): void => {};

interface IAwaitingStartClientDataProps {
  prospect: IProspect | null;
}

const AwaitingStartClientData = ({ prospect }: IAwaitingStartClientDataProps) => {
  const PROSPECT_PROFILE = TRANSLATIONS_PROSPECTS.profile;

  const { t } = useTranslation();

  if (!prospect) {
    return (
      <div className="client-data-card__section">
        <p className="profile-card__empty-hint">{t(TRANSLATIONS_CLIENTS.profile.notFound)}</p>
      </div>
    );
  }

  return (
    <>
      <div className="client-data-card__section">
        <h4 className="client-data-card__section-title">{t(PROSPECT_PROFILE.company.title)}</h4>
        <CompanyCard prospect={prospect} onUpdate={noopAsync} editing={false} onValidChange={noopValidChange} />
      </div>
      <div className="client-data-card__divider" />
      <div className="client-data-card__section">
        <h4 className="client-data-card__section-title">{t(PROSPECT_PROFILE.primaryContact.title)}</h4>
        <PrimaryContactCard
          prospect={prospect}
          onCreateContact={noopAsync}
          onUpdateContact={noopAsync}
          editing={false}
          onValidChange={noopValidChange}
        />
      </div>
      <div className="client-data-card__divider" />
      <div className="client-data-card__section">
        <h4 className="client-data-card__section-title">{t(PROSPECT_PROFILE.billingContact.title)}</h4>
        <BillingContactCard
          prospect={prospect}
          onCreateContact={noopAsync}
          onUpdateContact={noopAsync}
          editing={false}
          onValidChange={noopValidChange}
        />
      </div>
    </>
  );
};

export default AwaitingStartClientData;
